import React, { useState, useEffect, useRef } from 'react';
import '../Dropdown/Dropdown.css';
import FormularioMateriaPrima from './FormularioMateriaPrima';
import { useClienteDaProducao } from '../utils/clienteDaProducao';
import { ehPrincipal } from '../utils/responsavelPrincipal';

// Nova implementação limpa de FormularioGarantia
// - Coleta campos da Garantia
// - Permite adicionar vários responsáveis localmente com horas
// - Ao submeter, envia para o parent um objeto com os campos da garantia
//   e dois arrays: `responsaveis` (IDs) e `responsaveisDados` (horas)
function FormularioGarantia({
	onSubmit,
	onCancel,
	responsaveis = [], // lista de pessoas (Pessoas)
	producaoSelecionada = null,
	modoEdicao = false,
	dadosEdicao = null,
	onCriarResponsavel,
	// linked responsibilities for edit mode
	responsaveisGarantia = [],
	onAdicionarResponsavel,
	onRemoverResponsavel,
	onDefinirPrincipal, // marca/desmarca o responsável principal (edição)
	refFormularioMateriaPrima
}) {
	const [form, setForm] = useState(() => ({
		contratoId: '',
		id_cliente: producaoSelecionada?.clienteId || producaoSelecionada?.ClienteId || '',
		producoesId: producaoSelecionada?.producaoId || producaoSelecionada?.ProducaoId || '',
		dataSolicitacao: '',
		status: 'Solicitada',
		descricaoProblema: '',
		custoGarantia: '',
		pessoaId: null
	}));


	// Responsáveis: cada linha é editável inline
	const [responsaveisRows, setResponsaveisRows] = useState([
		{ pessoasId: '', horasPrevistas: '', horasReais: '' }
	]);

	// Controle de exibição do bloco de matérias-primas (delegado ao FormularioMateriaPrima)
	const [showMaterias, setShowMaterias] = useState(false);

	useEffect(() => {
		if (dadosEdicao) {
			setForm({
				contratoId: dadosEdicao.contratoId || dadosEdicao.ContratoId || '',
				id_cliente: dadosEdicao.id_cliente || dadosEdicao.Id_cliente || producaoSelecionada?.clienteId || producaoSelecionada?.ClienteId || '',
				producoesId: dadosEdicao.producoesId || dadosEdicao.ProducoesId || producaoSelecionada?.producaoId || producaoSelecionada?.ProducaoId || '',
				dataSolicitacao: dadosEdicao.dataSolicitacao || dadosEdicao.DataSolicitacao || '',
				status: dadosEdicao.status || dadosEdicao.Status || 'Solicitada',
				descricaoProblema: dadosEdicao.descricaoProblema || dadosEdicao.DescricaoProblema || '',
				custoGarantia: dadosEdicao.custoGarantia || dadosEdicao.CustoGarantia || '',
				pessoaId: dadosEdicao.pessoaId || dadosEdicao.PessoaId || null
			});
			// Parent should load existing responsaveis when editing; locais is only for new additions before save
			
			// Nenhuma ação: o FormularioMateriaPrima fará o GET para as matérias alocadas
		}
	}, [dadosEdicao, producaoSelecionada]);

	const setField = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

	// Cliente vem da produção (não é editável)
	useClienteDaProducao(form.producoesId, clienteId => setField('id_cliente', clienteId));

	// Quando for necessário ver as matérias alocadas, chamaremos a função imperativa
	// do FormularioMateriaPrima via `refFormularioMateriaPrima.current.carregarMateriasAlocadas()`.


	// Adiciona uma nova linha vazia
	const adicionarLinhaResponsavel = () => {
		setResponsaveisRows(prev => [...prev, { pessoasId: '', horasPrevistas: '', horasReais: '' }]);
	};

	// Remove uma linha
	const removerLinhaResponsavel = (idx) => {
		setResponsaveisRows(prev => prev.filter((_, i) => i !== idx));
	};

	// Atualiza campo de uma linha
	const atualizarCampoLinha = (idx, campo, valor) => {
		setResponsaveisRows(prev => prev.map((row, i) => i === idx ? { ...row, [campo]: valor } : row));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Validação básica
		if (!form.producoesId && !form.id_cliente) {
			alert('Preencha Projeto ou Cliente.');
			return;
		}


		// Monta payload conforme o backend espera para Garantia (campos em camelCase usados no parent)
		const payload = {
			contratoId: form.contratoId ? (isNaN(Number(form.contratoId)) ? null : parseInt(form.contratoId)) : null,
			id_cliente: form.id_cliente ? (isNaN(Number(form.id_cliente)) ? null : parseInt(form.id_cliente)) : null,
			producoesId: form.producoesId ? (isNaN(Number(form.producoesId)) ? null : parseInt(form.producoesId)) : null,
			dataSolicitacao: form.dataSolicitacao || null,
			status: form.status || 'Solicitada',
			descricaoProblema: form.descricaoProblema || null,
			custoGarantia: form.custoGarantia !== '' ? (isNaN(Number(form.custoGarantia)) ? null : parseFloat(form.custoGarantia)) : null,
			pessoaId: form.pessoaId ? (isNaN(Number(form.pessoaId)) ? null : parseInt(form.pessoaId)) : null,

			// Arrays para o parent criar Responsaveis e ResponsavelHoras
			responsaveis: responsaveisRows.filter(r => r.pessoasId).map(r => parseInt(r.pessoasId)),
			responsaveisDados: responsaveisRows.filter(r => r.pessoasId).map(r => ({
				horasPrevistas: r.horasPrevistas !== '' ? parseFloat(r.horasPrevistas) : 0,
				horasReais: r.horasReais !== '' ? parseFloat(r.horasReais) : 0,
				principal: !!r.principal
			}))
		};

		console.log('FormularioGarantia -> payload to parent:', payload);

		if (onSubmit) {
			// permitir que o parent trate o POST e a criação dos responsáveis/horas
			try {
				await onSubmit(payload);
			} catch (err) {
				console.error('Erro no onSubmit do parent:', err);
				alert('Erro ao salvar garantia: ' + (err.message || err));
			}
		}
	};

	return (
		<form onSubmit={handleSubmit} className="formulario-garantia-form">
			<div id="garantia-form-dados" className="formulario-garantia-grid">
				<div className="form-field">
					<label className="form-field-label">Projeto</label>
					<input value={form.producoesId} onChange={e => setField('producoesId', e.target.value)} className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">ID Cliente</label>
					<input value={form.id_cliente} readOnly title="O cliente vem do projeto" className="form-field-input" style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
				</div>
			</div>

			<div className="formulario-garantia-grid">
				<div className="form-field">
					<label className="form-field-label">Data Solicitação</label>
					<input type="date" value={form.dataSolicitacao ? form.dataSolicitacao.split('T')[0] : ''} onChange={e => setField('dataSolicitacao', e.target.value)} className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">Status</label>
					<select value={form.status} onChange={e => setField('status', e.target.value)} className="form-field-input">
						<option>Solicitada</option>
						<option>Em Análise</option>
						<option>Aprovada</option>
						<option>Em Andamento</option>
						<option>Concluída</option>
						<option>Recusada</option>
						<option>Cancelada</option>
					</select>
				</div>
			</div>


			<div className="formulario-garantia-grid">
				<div className="form-field">
					<label className="form-field-label">Custo (R$)</label>
					<input type="number" step="0.01" value={form.custoGarantia} onChange={e => setField('custoGarantia', e.target.value)} className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">Pessoa (opcional)</label>
					<select value={form.pessoaId || ''} onChange={e => setField('pessoaId', e.target.value ? parseInt(e.target.value) : null)} className="form-field-input">
						<option value="">--</option>
						{Array.isArray(responsaveis) && responsaveis.map(p => (
							<option key={p.id || p.Id} value={p.id || p.Id}>{p.nome || p.Nome}</option>
						))}
					</select>
				</div>
			</div>

			<div className="form-field form-field-full">
				<label className="form-field-label">Descrição do Problema</label>
				<textarea value={form.descricaoProblema} onChange={e => setField('descricaoProblema', e.target.value)} className="form-field-textarea" style={{ minHeight: 60 }} />
			</div>

			<hr />

			{/* Responsáveis na criação (com horas previstas); na edição eles ficam em "Responsáveis Vinculados" */}
			{!modoEdicao && (
			<div id="garantia-form-responsaveis" className="responsaveis-section-manutencao">
				<label className="responsaveis-header-manutencao">Responsáveis</label>
			<div className="responsaveis-list-manutencao">
				{responsaveisRows.map((row, idx) => (
					<div key={idx} className="responsavel-line-manutencao">
						<select value={row.pessoasId} onChange={e => atualizarCampoLinha(idx, 'pessoasId', e.target.value)} className="responsavel-select-manutencao">
							<option value="">Selecione uma pessoa</option>
							{Array.isArray(responsaveis) && responsaveis.map(p => (
								<option key={p.id || p.Id} value={p.id || p.Id}>{p.nome || p.Nome}</option>
							))}
						</select>
						<input type="number" step="0.25" min="0" placeholder="Hrs previstas" value={row.horasPrevistas} onChange={e => atualizarCampoLinha(idx, 'horasPrevistas', e.target.value)} className="responsavel-input-manutencao" title="Horas previstas (as reais são lançadas ao concluir a garantia)" />
					{/* Com mais de um responsável, pode marcar um como principal (opcional; só um) */}
					{responsaveisRows.filter(r => r.pessoasId).length > 1 && row.pessoasId && (
						<label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: row.principal ? 'rgb(235, 133, 0)' : '#555', cursor: 'pointer' }}>
							<input
								type="checkbox"
								checked={!!row.principal}
								onChange={() => setResponsaveisRows(prev => prev.map((r, i) => ({ ...r, principal: i === idx ? !row.principal : false })))}
							/>
							Principal
						</label>
					)}
					<div className="responsavel-actions-manutencao">
							<button type="button" onClick={adicionarLinhaResponsavel} className="btn-add-responsavel-manutencao">+</button>
							{responsaveisRows.length > 1 && (
								<button type="button" onClick={() => removerLinhaResponsavel(idx)} className="btn-remove-responsavel-manutencao">×</button>
							)}

							{idx === 0 && (
								<button type="button" onClick={onCriarResponsavel} className="btn-add-pessoa-manutencao">Adicionar nova pessoa</button>
							)}
						</div>
					</div>
				))}
			</div>
			</div>
			)}
			{/* Responsáveis Vinculados - SOMENTE EM MODO EDIÇÃO */}
			{modoEdicao && (
				<div id="garantia-form-responsaveis-vinculados" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
						<label style={{ fontWeight: '500', fontSize: '14px' }}>Responsáveis Vinculados</label>
						{onAdicionarResponsavel && (
							<button
								type="button"
								onClick={onAdicionarResponsavel}
								style={{ padding: '6px 12px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}
							>
								+ Adicionar
							</button>
						)}
					</div>
					{responsaveisGarantia && responsaveisGarantia.length > 0 ? responsaveisGarantia.map((resp, idx) => (
						<div key={idx} style={{ padding: '10px', backgroundColor: 'white', borderRadius: '5px', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<div>
								<div style={{ fontWeight: '500', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
									{resp.nome || resp.Nome || resp.nomePessoa || resp.NomePessoa}
									{/* Responsável principal: só um por garantia (com um só, ele já é o principal) */}
									{onDefinirPrincipal ? (
										<button
											type="button"
											onClick={() => onDefinirPrincipal(resp)}
											title={ehPrincipal(resp) ? 'Clique para deixar de ser o principal' : 'Tornar este o responsável principal (só um)'}
											style={{ padding: '3px 10px', borderRadius: 12, border: '1px solid rgb(235, 133, 0)', cursor: 'pointer', fontSize: 11, fontWeight: 700, background: ehPrincipal(resp) ? 'rgb(235, 133, 0)' : '#fff', color: ehPrincipal(resp) ? '#fff' : 'rgb(235, 133, 0)' }}
										>
											{ehPrincipal(resp) ? '⭐ Principal' : '☆ Tornar principal'}
										</button>
									) : ehPrincipal(resp) && <span style={{ fontSize: 11, color: 'rgb(235, 133, 0)' }}>⭐ Principal</span>}
								</div>
								<div style={{ fontSize: 12, color: '#666' }}>
									{(resp.custoHora || resp.CustoHora) ? `R$ ${(resp.custoHora || resp.CustoHora).toFixed(2)}/h` : ''}
									{(resp.horasPrevistas || resp.horasReais || resp.HorasPrevistas || resp.HorasReais) ? ` | Prev: ${resp.horasPrevistas || resp.HorasPrevistas || 0}h (bloqueado) / Real: ${resp.horasReais || resp.HorasReais || 0}h` : ''}
								</div>
							</div>
							{onRemoverResponsavel && (
								<button type="button" onClick={() => onRemoverResponsavel(resp)} style={{ padding: '4px 8px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }}>Remover</button>
							)}
						</div>
					)) : (
						<div style={{ fontSize: 13, color: '#666', padding: '6px 0' }}>Nenhum responsável vinculado.</div>
					)}
				</div>
			)}
			
			{/* Container de Matérias-Primas (CRIAÇÃO e EDIÇÃO) */}
			{((!modoEdicao) || (modoEdicao && dadosEdicao)) && (
				<div id="garantia-form-materias" style={{ marginTop: 20, padding: 15, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0' }}>
					<h4 style={{ margin: '0 0 12px 0', color: 'rgb(235, 133, 0)', fontSize: 14 }}>Matérias-Primas</h4>
					<FormularioMateriaPrima 
						ref={refFormularioMateriaPrima}
						tarefaId={dadosEdicao?.id || dadosEdicao?.Id}
						tipoId="garantia"
						onMateriaPrimaAdded={(result) => {
							console.log('✅ Matéria-prima adicionada:', result);
						}}
						modoEdicao={modoEdicao}
					/>
				</div>
			)}

			{/* Matérias-Primas - view via FormularioMateriaPrima (delegated) */}
			{modoEdicao && dadosEdicao && (
				<div style={{ marginTop: 20 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
						<div>
							{/* botão 'Ver Matérias-Primas Alocadas' removido conforme solicitado */}
							{showMaterias && (
								<button
									onClick={() => setShowMaterias(false)}
									style={{ padding: '8px 12px', backgroundColor: '#9e9e9e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
								>
									Fechar
								</button>
							)}
						</div>
					</div>
					{showMaterias && (
						<div style={{ marginTop: 12, padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0' }}>
							<FormularioMateriaPrima
								ref={refFormularioMateriaPrima}
								tarefaId={dadosEdicao.id || dadosEdicao.Id}
								tipoId="garantia"
								modoEdicao={modoEdicao}
								onClose={() => setShowMaterias(false)}
							/>
						</div>
					)}
				</div>
			)}

			<div className="form-buttons-container-garantia">
				<button type="button" onClick={onCancel} className="btn-cancelar-garantia">Cancelar</button>
				<button type="submit" className="btn-salvar-garantia">Salvar Garantia</button>
			</div>
		</form>
	);
}

export default FormularioGarantia;

